"use strict";
/* eslint-disable camelcase */
Object.defineProperty(exports, "__esModule", { value: true });
class BeCropReport {
    constructor(bcReport) {
        this.shi_rank = bcReport.shi_rank || 0;
        this.biodiversity_rank = bcReport.biodiversity_rank || 0;
        this.functionality_rank = bcReport.functionality_rank || 0;
        this.resistance_rank = bcReport.resistance_rank || 0;
        this.healthiness_rank = bcReport.healthiness_rank || 0;
        this.biocontrol_rank = bcReport.biocontrol_rank || 0;
        this.hormoneprod_rank = bcReport.hormoneprod_rank || 0;
        this.stressadapt_rank = bcReport.stressadapt_rank || 0;
        this.nutrition_c_rank = bcReport.nutrition_c_rank || 0;
        this.nutrition_n_rank = bcReport.nutrition_n_rank || 0;
        this.nutrition_p_rank = bcReport.nutrition_p_rank || 0;
        this.nutrition_k_rank = bcReport.nutrition_k_rank || 0;
    }
    get biodiversityRow() {
        return [this.shi_rank, this.biodiversity_rank, this.functionality_rank, this.resistance_rank];
    }
    get healthRow() {
        return [this.healthiness_rank, this.biocontrol_rank, this.hormoneprod_rank, this.stressadapt_rank];
    }
    get nutrientsRow() {
        return [this.nutrition_c_rank, this.nutrition_n_rank, this.nutrition_p_rank, this.nutrition_k_rank];
    }
    get builtReport() {
        return [...this.biodiversityRow, ...this.healthRow, ...this.nutrientsRow];
    }
}
exports.default = BeCropReport;
